import { useState } from "react"
import BookCard from "./BookCard"
import BookModal from "./BookModal"

// The whole bookshelf screen. Receives books from the server (via the Stimulus
// mount) and owns the "which book is open" state — clicking a card opens the modal.
const BooksIndex = ({ books }) => {
  const [selected, setSelected] = useState(null)

  return (
    <>
      <header className="page-head">
        <h1>Книжкова полиця</h1>
        <p className="subtitle">Прочитане, що варто пам'ятати</p>
        <div className="divider" />
      </header>

      {books.length > 0 ? (
        <section className="shelf">
          {books.map((book) => (
            <BookCard key={book.id} book={book} onOpen={() => setSelected(book)} />
          ))}
        </section>
      ) : (
        <div className="shelf-empty">
          <h2>Полиця поки порожня</h2>
          <p>Додай першу прочитану книжку — і вона стане тут.</p>
        </div>
      )}

      <div className="shelf-actions">
        <a className="btn btn-primary" href="/books/new">
          ＋ Додати книжку
        </a>
      </div>

      <BookModal book={selected} onClose={() => setSelected(null)} />
    </>
  )
}

export default BooksIndex
